import { FC } from "react";

interface PaybackProps {
    graficoConsumo: string,
    graficoPayback: string,
    consumo_total: number,
    geracao_total: number,
    valor_servico: number,
    rangePayback: string,
    gerarGradicoConsumo: boolean;
}

const Payback: FC<PaybackProps> = ({
    graficoConsumo,
    graficoPayback,
    consumo_total,
    geracao_total,
    valor_servico,
    rangePayback,
    gerarGradicoConsumo,
}) => {
    return <>
        <div className="title">Retorno financeiro</div>

        <div className="sub-title-minor text-black">Gráfico de tempo de retorno sobre o investimento (Payback)</div>

        <img src={`data:tipo_da_imagem/extensao;base64,${graficoPayback}`} className="grafConsumoPayback" alt="Imagem grafico consumo payback" />
        <div className="textGraficos">Payback Aproximado: {rangePayback}</div>

        <div className="container-prazo-entrega">
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-payback"><span>O payback foi calculado tendo como referência o preço do gerador fotovoltaico com pagamento à vista, desconsiderando taxas de juros e outros custos decorrentes de financiamento.</span></div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-payback"><span>Considerando um aumento anual médio na tarifa de energia elétrica de 6,00%.</span></div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-payback"><span>Considerando performance conforme disponibilizado no datasheet do módulo fotovoltaico,
                    sendo a garantia de desempenho mínimo de 84,8% do seu desempenho nominal no 25° ano
                    de operação.</span></div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-payback"><span>Cálculo considerando as alterações propostas na REN 1.059/2023, Lei 14.300/22 e REN
                    1.000/21 da ANEEL.</span></div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-payback"><span>A Tarifa de energia elétrica é baseada nos dados disponibilizados pela Aneel, para cada
                    concessionária ou permissionária de distribuição de energia elétrica.</span></div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-payback"><span>Esses valores são de referência e podem variar considerando condições climáticas, ajustes
                    tarifários, ajustes fiscais, políticas publicas e normas que venham a mudar ao longo dos anos.</span></div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-payback"><span>Os cálculos já consideram a taxa mínima da concessionária (Custo de disponibilidade =
                    valor cobrado pela concessionária mesmo que o consumo de energia elétrica seja zero).</span></div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-payback"><span>Tempo para retorno sobre o investimento (payback): {rangePayback}</span></div>
            </div>

            {!valor_servico ? (
                <div className="item-prazo-entrega">
                    <div className="marcador-prazo-entrega" >»</div>
                    <div className="texto-payback"><span>Este cálculo não está considerando o valor da instalação.</span></div>
                </div>
            ) : null}
        </div>
    </>
}

export default Payback;